<template>
  <div
    id="app"
    :class="{
      'ltr_default': css_direction === 'ltr',
      'rtl_default': css_direction === 'rtl',
      }"
  >
    <div
      class="container_main"
      v-if="$store.getters.outlet || webviewGuard === true"
    >
      <block-popup v-if="$store.getters.modal.block"></block-popup>
      <CallWaiterModal />
      <TopBar v-if="$store.getters.outlet && $store.getters.showCallingWaiterButton && $store.getters.contactlessMode" />
      <transition
        :name="'header-fade'"
        mode="out-in"
      >
        <Header v-if="$route.name === 'home' && $store.getters.outlet"/>
      </transition>
      <keep-alive>
        <transition
          :name="transition"
          mode="out-in"
        >
          <router-view/>
        </transition>
      </keep-alive>
    </div>
    <Footer v-if="
        $route.name === 'home' &&
        $store.getters.outlet &&
        !$store.getters.overlay
      "/>
  </div>
</template>

<script>
  import '@/lazyLoadLib.js'
  import loader from '@/loader'
  import {FETCH_OUTLET} from '@/store/actions.type'
  import {SET_MODAL} from '@/store/mutations.type'
  import VueGtm from 'vue-gtm'
  import Vue from 'vue'
  import BlockPopup from '@/components/Default/BlockPopup'
  import {appMixin} from '@/mixins/app'
  import CallWaiterModal from "@/components/ECommerce/CallWaiterModal";
  
  console.log('app default')

  export default {
    mixins: [appMixin],
    data: () => ({}),
    components: {
      BlockPopup,
      CallWaiterModal,
      TopBar: () => import(/* webpackPrefetch: true */ "@/" + loader.component("TopBar")),
      Header: () => import(/* webpackPrefetch: true */ '@/' + loader.component('Header')),
      Footer: () => import(/* webpackPrefetch: true */ '@/' + loader.component('Footer'))
    },
    async created() {
      await this.initApp()
    },

    methods: {
      startWebview() {
        this.$store.dispatch(FETCH_OUTLET, {
          page: 1,
          only_popular: false,
          get_settings: true
        })

        let clickHandler =
          'ontouchstart' in document.documentElement ? 'touchstart' : 'click'

        document.addEventListener(
          clickHandler,
          event => {
            if (event.target.classList.contains('popup_click_hide')) {
              event.stopPropagation()
              setTimeout(() => {
                for (let name in this.$store.getters.modal) {
                  if (name !== 'block') {
                    if (this.$store.getters.modal[name] === true) {
                      this.$store.commit(SET_MODAL, {
                        modal: name,
                        status: false
                      })
                    }
                  }
                }
              }, 100)
              return false
            }
          },
          false
        )
      }
    },

    computed: {
      transition() {
        if (
          (this.$route.name === 'receipt' && this.css_direction === 'rtl') ||
          (this.$route.name === 'form' && this.css_direction === 'rtl')
        ) {
          return 'rtl-slide-fade'
        } else if (
          this.$route.name === 'receipt' ||
          this.$route.name === 'form'
        ) {
          return 'slide-fade'
        }
        return 'view-fade'
      }
    },

    watch: {
      gtmTag(gtmTag) {
        if (gtmTag) {
          Vue.use(VueGtm, {
            id: gtmTag, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
            enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
            debug: false, // Whether or not display console logs debugs (optional)
            loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
            vueRouter: this.$router // Pass the router instance to automatically sync with router (optional)
          })
        }
      }
    }
  }
</script>
